<template>
    <base-box
        v-bind="$props"
        border-radius="large"
        border
        border-color="default"
        data-testid="affiliate-links-card"
        v-on="$listeners"
    >
        <div slot="content">
            <g-tag v-if="canCreateDeepLink" theme="primary" class="g-mb-3">New - create your own links</g-tag>
            <g-level vertical-align="top" class="flex-fix">
                <g-level-item class="flex-fix">
                    <div>
                        <g-typography
                            tag="h4"
                            color="normal"
                            font-weight="semibold"
                            value="Your Links"
                            class="g-mb-3"
                        />
                        <g-typography tag="h5" color="secondary" font-weight="normal" :value="numLinksCopy" />
                    </div>
                </g-level-item>
                <g-level-item slot="right">
                    <g-button
                        size="large"
                        shape="round"
                        theme="live"
                        type="default"
                        data-testid="links-view-button"
                        @click="handleClick"
                    >
                        View
                    </g-button>
                </g-level-item>
            </g-level>
        </div>
    </base-box>
</template>

<script>
    import useRouter from '../../../../../src/composables/use-router';
    import useEventTracking from "../../../../../src/composables/use-event-tracking";
    import { EVENT_VIEW_AFFILIATE_LINKS } from '../../../../constants/analytics-events';
    import {useContactStore} from "../../../../../stores";

    export default {
        name: 'AffiliateLinksCard',
        props: {
            numberOfLinks: {
                type: Number,
                required: true
            },
            canCreateDeepLink: {
                type: Boolean,
                default: false
            }
        },
        setup(props) {
            const router = useRouter().get();
            const numLinksCopy = props.numberOfLinks === 1 ? '1 Item' : `${props.numberOfLinks} Items`;
            const handleClick = () => {
                const contact = useContactStore().data;
                const eventTracking = useEventTracking();
                eventTracking.trackEvent(EVENT_VIEW_AFFILIATE_LINKS, {
                    contact_id: contact?.id
                });

                router.push({ name: 'v2.activation.brief.links' });
            };

            return {
                handleClick,
                numLinksCopy
            };
        }
    };
</script>

<style scoped lang="scss"></style>
